import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasComportamentosAssociados
    ? _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      icon: "info",
                      message: "Não há comportamentos associados cadastrados.",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            VRow,
            { attrs: { id: "grafico-barras", "no-gutters": "" } },
            [
              _c(
                VCol,
                [
                  _c("bar-chart", {
                    staticClass: "chart",
                    attrs: {
                      categorias: _vm.dadosBarchart.categorias,
                      dados: _vm.dadosBarchart.dados,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      tooltip: _vm.dadosBarchart.tooltip,
                      "data-type": "integer",
                      "descricao-eixo-y": "Comportamentos Associados",
                      titulo:
                        "Monitoramento Geral de Competências Comportamentais",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { id: "grafico-pizza", "no-gutters": "" } },
            [
              _c(
                VCol,
                [
                  _c("pie-chart", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.visualizacaoCompetencias === "associados",
                        expression: "visualizacaoCompetencias === 'associados'",
                      },
                    ],
                    staticClass: "chart",
                    attrs: {
                      dados: _vm.dadosPiechartAssociados.dados,
                      "dados-complementares":
                        _vm.dadosPiechartAssociados.dadosComplementares,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      titulo: "Comparativo de Competências Comportamentais",
                    },
                  }),
                  _vm.hasComportamentosConsolidados
                    ? _c("pie-chart", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.visualizacaoCompetencias === "consolidados",
                            expression:
                              "visualizacaoCompetencias === 'consolidados'",
                          },
                        ],
                        staticClass: "chart",
                        attrs: {
                          dados: _vm.dadosPiechartConsolidados.dados,
                          "dados-complementares":
                            _vm.dadosPiechartConsolidados.dadosComplementares,
                          fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                          titulo: "Comparativo de Competências Comportamentais",
                        },
                      })
                    : _c("app-alert", {
                        attrs: {
                          icon: "info",
                          message:
                            "Não há comportamentos associados cadastrados.",
                          type: "info",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "justify-center" },
            [
              _c(
                VRadioGroup,
                {
                  attrs: { row: "" },
                  model: {
                    value: _vm.visualizacaoCompetencias,
                    callback: function ($$v) {
                      _vm.visualizacaoCompetencias = $$v
                    },
                    expression: "visualizacaoCompetencias",
                  },
                },
                [
                  _c(VRadio, {
                    attrs: { label: "Associados", value: "associados" },
                  }),
                  _c(VRadio, {
                    attrs: { label: "Consolidados", value: "consolidados" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VToolbar,
                { attrs: { flat: "" } },
                [
                  _c(VToolbarTitle, [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "title primary--text text--darken-1 text-no-wrap mt-0",
                      },
                      [_vm._v(" RESULTADOS ")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-sort", {
                    model: {
                      value: _vm.opcoes,
                      callback: function ($$v) {
                        _vm.opcoes = $$v
                      },
                      expression: "opcoes",
                    },
                  }),
                ],
                1
              ),
              _c(VSpacer),
              _c(
                VCol,
                [
                  _c("app-search", {
                    model: {
                      value: _vm.opcoes,
                      callback: function ($$v) {
                        _vm.opcoes = $$v
                      },
                      expression: "opcoes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(VDataTable, {
                    staticClass: "elevation-0",
                    attrs: {
                      headers: _vm.dadosTabela.headers,
                      items: _vm.dadosTabela.items,
                      search: _vm.opcoes.pesquisa,
                      "sort-by": _vm.opcoes.ordenarPor,
                      "sort-desc": _vm.opcoes.decrescente,
                      "align-content-space-between": "",
                      "disable-pagination": "",
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.unidade`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c("span", _vm._g({}, on), [
                                              _vm._v(
                                                _vm._s(item.unidade.sigla)
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.unidade.nome)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `body.append`,
                          fn: function () {
                            return [
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "subtitle-2 grey--text text--darken-2",
                                      },
                                      [
                                        _vm._v(
                                          "Total de Comportamentos Associados"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._l(
                                    _vm.dadosTabela.totalAssociados,
                                    function (c, ix) {
                                      return _c("td", { key: `${c}_${ix}` }, [
                                        _c("strong", [_vm._v(_vm._s(c))]),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "subtitle-2 grey--text text--darken-2",
                                      },
                                      [
                                        _vm._v(
                                          "Total de Comportamentos Consolidados"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._l(
                                    _vm.dadosTabela.totalConsolidados,
                                    function (c, ix) {
                                      return _c("td", { key: `${c}_${ix}` }, [
                                        _c("strong", [_vm._v(_vm._s(c))]),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(VDivider),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VToolbar,
                { attrs: { flat: "" } },
                [
                  _c(VToolbarTitle, [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "title primary--text text--darken-1 text-no-wrap mt-0",
                      },
                      [
                        _vm._v(
                          ' LISTA DE NÃO-COMPORTAMENTOS (CATEGORIA "OUTROS") (' +
                            _vm._s(_vm.naoComportamentos.length) +
                            ") "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(VCol, [
                _c(
                  "ul",
                  _vm._l(_vm.naoComportamentosOrdenados, function (c, ix) {
                    return _c("li", { key: `${c}_${ix}` }, [
                      _vm._v(" " + _vm._s(c.descricaoAtualizada) + " "),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "justify-end mb-1" },
            [
              _c(
                VTooltip,
                {
                  attrs: { "max-width": "400", top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              {
                                attrs: { color: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getRelatorio()
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(VIcon, [_vm._v("get_app")]),
                              _vm._v(" BAIXAR PDF "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Clique para baixar o relatório dos dados em formato PDF."
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }